<div class="col-xxl-12 col-xl-12 col-lg-12 d-grid gap-4 p-3 bg-white rounded-3" *ngIf="programs?.length ?? 0 > 0">
    <h3 class="fw-bold">CHƯƠNG TRÌNH ĐỒNG HÀNH CỦA BẠN</h3>

    <div *ngFor="let program of programs" class="d-flex gap-4 align-items-center">
        <div class="row p-3">
            <div class="col-xxl-4 col-xl-4 col-lg-4 col-sm-4 d-flex justify-content-center align-items-center">
                <img [src]="program.imageUrl" [alt]="program.name" style="width: 100%; height: 100%;"  loading="lazy" />
            </div>
            <div class="col-xxl-8 col-xl-8 col-lg-8 col-sm-8 d-flex flex-column gap-3 div-right">
                <div class="d-flex flex-column justify-content-between gap-5">
                    <div class="d-grid gap-3">
                        <h4 class="fw-bold" style="color: var(--theme-color);">{{ program.name }}</h4>
                        <h5 class="fw-bold">{{ program.title }}</h5>
                        <h5 class="">{{ program.description }}</h5>
                    </div>
                    <div>
                        <p class="">Thời gian: {{ program.startDate | date: 'dd/MM/yyyy' }}</p>
                        <div class="d-flex justify-content-between align-items-center">
                            <a *ngIf="program.registrationStatus == 40" class="btn btn-regster"
                                [routerLink]="['register', program.slug]">
                                <img src="assets/svg/register-event.svg" style="width: 24px; height: 24px;"  loading="lazy" />
                                Đăng ký
                            </a>
                            <button *ngIf="program.registrationStatus == 1" class="btn btn-already-register">
                                Đã đăng ký
                            </button>
                            <div *ngIf="program.registrationStatus == 2" class="badge badge-info text-bg-warning fs-6">
                                Đã hết hạn
                            </div>
                            <label class="link" (click)="viewDetails(program.detailLink)">
                                Xem chi tiết>>>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="col-xxl-12 col-xl-12 col-lg-12 d-grid gap-4 p-3 bg-white rounded-3" *ngIf="programs?.length == 0">
    <h3 class="fw-bold">CHƯƠNG TRÌNH ĐỒNG HÀNH CỦA BẠN</h3>
    <div class="d-flex justify-content-center align-items-center" style="height: 200px">
        <img src="assets/svg/no-data.svg" alt="no-data" style="width: 100px; height: 100px"  loading="lazy" />
    </div>
    <h4 class="text-center">Hiện chưa có chương trình khả dụng</h4>
</div>